import Cookies from "js-cookie";
import { getAuthConfig } from "../auth-config/auth-config.service";
import type { TAuthCookies } from "./auth-cookies.types";

export const getAuthCookies = (): TAuthCookies => {
  const config = getAuthConfig();

  return {
    idToken: Cookies.get(config.cookieJwtName) ?? null,
    refreshToken: Cookies.get(config.cookieRefreshName) ?? null,
    accessToken: Cookies.get(config.cookieAccessName) ?? null,
    userHash: Cookies.get(config.cookieUserHash) ?? null,
  };
};

export const setAuthCookies = (tokens: {
  idToken: string;
  refreshToken: string;
  accessToken: string;
  userHash: string;
}): void => {
  const config = getAuthConfig();
  const isLocalhost = globalThis.location?.hostname === "localhost";

  const cookieOptions: Cookies.CookieAttributes = {
    expires: 365,
    domain: isLocalhost ? undefined : config.cookieDomain,
    secure: !isLocalhost,
    sameSite: "lax" as const,
  };

  Cookies.set(config.cookieJwtName, tokens.idToken, cookieOptions);
  Cookies.set(config.cookieRefreshName, tokens.refreshToken, cookieOptions);
  Cookies.set(config.cookieAccessName, tokens.accessToken, cookieOptions);
  Cookies.set(config.cookieUserHash, tokens.userHash, cookieOptions);
};

export const clearAuthCookies = (): void => {
  const config = getAuthConfig();
  const isLocalhost = globalThis.location?.hostname === "localhost";

  const removeOptions: Cookies.CookieAttributes = {
    domain: isLocalhost ? undefined : config.cookieDomain,
  };

  Cookies.remove(config.cookieJwtName, removeOptions);
  Cookies.remove(config.cookieRefreshName, removeOptions);
  Cookies.remove(config.cookieAccessName, removeOptions);
  Cookies.remove(config.cookieUserHash, removeOptions);

  for (let i = 0; i < 5; i++) {
    Cookies.remove(`${config.cookieJwtName}_${i}`, removeOptions);
  }
};
